import { Button, Icon } from "@/shared/ui";

type Props = {
  onClose?: () => void;
  title: string;
};

export default function CreateEntityTitle({ onClose, title }: Props) {
  return (
    <div className="flex items-center justify-between">
      <div className="text-18 font-bold text-white">{title}</div>
      {onClose && (
        <Button color="gray" variant="soft" className="p-0 w-[2rem] h-[2rem]" onClick={onClose}>
          <Icon name="close" className="w-2.5" />
        </Button>
      )}
    </div>
  );
}
